import { mount } from "@vue/test-utils";
import SelectAutocomplete from "@/components/core/custom/SelectAutocomplete";

jest.mock("@/components/core/custom/SelectAutocomplete", () => ({
  default: {}
}));

describe("SelectAutocomplete test", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = mount(SelectAutocomplete);
  });

  it("Match con el snapshot", async () => {
    expect(wrapper.html()).toMatchSnapshot();
  });

  it("Render del component SelectAutocomplete", () => {
    expect(wrapper).toBeDefined();
  });
});
